import tmhRequest from '@/config/tmhRequest'


export default {
    searchFinanceInfo: function (data) {
        return tmhRequest({
            url: '/finance/tmh/financeinfo/searchfinanceinfo',
            method: 'post',
            params: data,
        })
    },

    searchFinanceInfoCount: function (data) {
        return tmhRequest({
            url: '/finance/tmh/financeinfo/searchfinanceinfocount',
            method: 'post',
            data: data,
        })
    },

    searchFinanceInfoByPage: function (data) {
        return tmhRequest({
            url: '/finance/tmh/financeinfo/searchfinanceinfobypage',
            method: 'post',
            data: data,
        })
    },

    addFinanceInfo: function (data) {
        return tmhRequest({
            url: '/finance/tmh/financeinfo/addfinanceinfo',
            method: 'post',
            params: data,
        })
    },

    editFinanceInfo: function (data) {
        return tmhRequest({
            url: '/finance/tmh/financeinfo/editfinanceinfo',
            method: 'post',
            params: data,
        })
    },

    multiLinkInvoiceItem: function (data) {
        return tmhRequest({
            url: '/finance/tmh/financeinfo/multilinkinvoiceitem',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/finance/financeinfo.js